import { Input } from './ui/input'
import { memo } from 'react'
import { cn } from '../lib/utils'
import { Search } from 'lucide-react'

interface SearchInputProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}

// Memoized component to prevent unnecessary re-renders
export const SearchInput = memo(function SearchInput({
  value,
  onChange,
  placeholder = 'Search...',
  className = 'w-[280px]',
}: SearchInputProps) {
  return (
    <div className="relative">
      <Search className="text-card-text absolute left-4 top-1/2 transform -translate-y-1/2 h-3.5 w-3.5" />
      <Input
        placeholder={placeholder}
        className={cn('h-[40px] pl-[39px] rounded-3xl bg-white', className)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
})
